import React, { memo, FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { Typography, Select, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import usePlacementSelection from "./usePlacementSelection";

const StyledDivRow = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledDivCol = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingBottom: 20,
});

const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  fontSize: 20,
  paddingTop: 10,
  paddingBottom: 40,
});

const BifoldComboPlacementAccordian: FC = () => {
  const {
    handleSelectionLeft,
    handleSelectionRight,
    comboUnitLeft,
    comboUnitRight,
  } = usePlacementSelection();

  return (
    <ReusableAccordian
      accordionName="corner"
      heading="Door/Window Combo Placement"
      secondaryHeading="Select door/window placement"
      required5={true}
      colOrRow="col"
    >
      <Typography>As viewed from Exterior</Typography>
      
      <StyledDivRow>
        <StyledDivCol style={{ paddingRight: 100 }}>
          <StyledTypography>Left Side</StyledTypography>

          <Select
            style={{ width: 120, backgroundColor: "white" }}
            value={comboUnitLeft || ""}
            onChange={handleSelectionLeft}
          >
            <MenuItem value="Door">Door</MenuItem>
            <MenuItem value="Window">Window</MenuItem>
          </Select>
        </StyledDivCol>

        <StyledDivCol>
          <StyledTypography>Right Side</StyledTypography>
          <Select
            style={{ width: 120, backgroundColor: "white" }}
            value={comboUnitRight || ""}
            onChange={handleSelectionRight}
          >
            <MenuItem value="Door">Door</MenuItem>
            <MenuItem value="Window">Window</MenuItem>
          </Select>
        </StyledDivCol>
      </StyledDivRow>
    </ReusableAccordian>
  );
};

export default memo(BifoldComboPlacementAccordian);
